import { DataTableColumnHeader } from "@/shared/components/table";
import { Checkbox } from "@/shared/components/ui/checkbox";
import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import type { DataForwarderRetryRow } from "../types/recover-types";

export function useDataForwarderRetryColumns() {
    return useMemo<ColumnDef<DataForwarderRetryRow>[]>(
        () => [
            {
                id: "select",
                header: ({ table }) => (
                    <Checkbox
                        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
                        onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
                        aria-label="Select all"
                    />
                ),
                cell: ({ row }) => (
                    <Checkbox
                        checked={row.getIsSelected()}
                        onCheckedChange={(v) => row.toggleSelected(!!v)}
                        aria-label="Select row"
                        onClick={(e) => e.stopPropagation()}
                    />
                ),
                size: 50,
                minSize: 50,
                maxSize: 50,
                enableSorting: false,
                enableHiding: false,
                enableResizing: false,
            },
            { accessorKey: "transId", header: ({ column }) => <DataTableColumnHeader column={column} title="trans_id" /> },
            { accessorKey: "dwAccountId", header: ({ column }) => <DataTableColumnHeader column={column} title="DW Account ID" /> },
            { accessorKey: "orgName", header: ({ column }) => <DataTableColumnHeader column={column} title="조직명" /> },
            { accessorKey: "targetDate", header: ({ column }) => <DataTableColumnHeader column={column} title="Target Date" /> },
            { accessorKey: "channel", header: ({ column }) => <DataTableColumnHeader column={column} title="채널" /> },
            { accessorKey: "reportTypesJson", header: ({ column }) => <DataTableColumnHeader column={column} title="리포트 타입" /> },
            { accessorKey: "status", header: ({ column }) => <DataTableColumnHeader column={column} title="상태" /> },
            { accessorKey: "createdAt", header: ({ column }) => <DataTableColumnHeader column={column} title="생성 시각" /> },
        ],
        []
    );
}